import { redirect, RouterProvider } from '@tanstack/react-router';
import { isAxiosError } from 'axios';

import { queryClient } from '@/app/lib/tanstack-query';
import { router } from '@/app/lib/tanstack-router';
import { getCurrentUserQueryOptions } from '@/shared/user/queries';

import { CurrentUserResponse } from './network/models/v1/user';

export function AppRouter() {
  return (
    <RouterProvider
      router={router}
      defaultPreload="intent"
      scrollRestoration={true}
      defaultStaleTime={1}
      context={{
        queryClient,
        ensureUser: async () => {
          const queryKey = getCurrentUserQueryOptions().queryKey;
          let user = queryClient.getQueryData<CurrentUserResponse>(queryKey);

          try {
            user = await queryClient.fetchQuery<CurrentUserResponse>({ ...getCurrentUserQueryOptions() });
          } catch (error) {
            const isUnauthorized = isAxiosError(error) && error.status === 401;

            // if the error is unauthorized, clear the user so they are redirected to login
            if (isUnauthorized) {
              user = undefined;
            }
          }

          if (!user) {
            throw redirect({ to: '/login' }); // TODO get the current location and use it on login
          }

          return user;
        }
      }}
    />
  );
}
